import { defineComponent as _, ref as f, watch as C, openBlock as I, createElementBlock as y, unref as T, normalizeStyle as A } from "vue";
var g = ((e) => (e.reactUi = "client-sdk-react-ui", e.vanillaUi = "client-sdk-vanilla-ui", e))(g || {}), N = ((e) => (e.prod = "https://www.crossmint.com", e.staging = "https://staging.crossmint.com", e.dev = "http://localhost:3001", e))(N || {}), S = ((e) => (e.clientVersion = "X-Client-Version", e.clientName = "X-Client-Name", e))(S || {}), v = ((e) => (e.CANDY_MACHINE = "candy-machine", e.SOLANA_AUCTION = "solana-auction", e.ERC_721 = "erc-721", e))(v || {}), h = ((e) => (e.WAITING_SUBMISSION = "waiting-submission", e.PENDING = "pending", e.REJECTED = "rejected", e.ACCEPTED = "accepted", e.INVALID = "invalid", e))(h || {}), m = (e = "") => e === "staging" ? "https://staging.crossmint.com" : ["prod", "production"].includes(e) || !e ? "https://www.crossmint.com" : e, D = { PAYMENT_PREPARATION_FAILED: "payment:preparation.failed", PAYMENT_PROCESS_CANCELED: "payment:process.canceled", PAYMENT_PROCESS_REJECTED: "payment:process.rejected" }, P = { PAYMENT_PREPARATION_SUCCEEDED: "payment:preparation.succeeded", PAYMENT_PROCESS_STARTED: "payment:process.started", PAYMENT_PROCESS_SUCCEEDED: "payment:process.succeeded", ...D }, R = { ORDER_PROCESS_STARTED: "order:process.started", ORDER_PROCESS_FINISHED: "order:process.finished" }, O = { QUOTE_STATUS_CHANGED: "quote:status.changed", QUOTE_STATUS_INVALIDATED: "quote:status.invalidated" }, U = { RECIPIENT_WALLET_CHANGED: "recipient:wallet.changed" }, L = { TRANSACTION_FULFILLMENT_FAILED: "transaction:fulfillment.failed" }, w = { TRANSACTION_FULFILLMENT_SUCCEEDED: "transaction:fulfillment.succeeded", ...L }, p = { ...P, ...R, ...O, ...U, ...w }, M = { PARAMS_UPDATE: "params-update" }, F = { UI_HEIGHT_CHANGED: "ui:height.changed" };
function k({ clientId: e, uiConfig: n, recipient: r, environment: s, mintConfig: i, locale: d }) {
  let c = m(s);
  function u() {
    let a = new URLSearchParams({ clientId: e });
    return n != null && a.append("uiConfig", JSON.stringify(n)), r != null && a.append("recipient", JSON.stringify(r)), i != null && a.append("mintConfig", JSON.stringify(i)), d != null && a.append("locale", d), `${c}/sdk/paymentElement?${a.toString()}`;
  }
  function o(a) {
    window.addEventListener("message", (t) => {
      t.origin === c && Object.values(p).includes(t.data.type) && a(t);
    });
  }
  function l(a) {
    var t;
    let E = document.getElementById("iframe-crossmint-payment-element");
    (t = E == null ? void 0 : E.contentWindow) == null || t.postMessage({ type: M.PARAMS_UPDATE, payload: a }, c);
  }
  return { getIframeUrl: u, listenToEvents: o, emitQueryParams: l };
}
function $({ environment: e } = {}) {
  function n({ orderIdentifier: s }, i) {
    let d = [], c = [], u = [];
    function o(t) {
      i(t), d.push(t.type), t.type === p.ORDER_PROCESS_FINISHED && clearInterval(a);
    }
    function l(t) {
      if (t.payload.transactionIdentifier) {
        if (t.type === p.TRANSACTION_FULFILLMENT_SUCCEEDED) {
          if (c.includes(t.payload.transactionIdentifier))
            return;
          c.push(t.payload.transactionIdentifier), o(t);
        } else if (t.type === p.TRANSACTION_FULFILLMENT_FAILED) {
          if (u.includes(t.payload.transactionIdentifier))
            return;
          u.push(t.payload.transactionIdentifier), o(t);
        }
      }
    }
    let a = setInterval(async () => {
      let t = await r({ orderIdentifier: s });
      for (let E of t)
        d.includes(E.type) ? l(E) : o(E);
    }, 5e3);
    window.onpopstate = () => {
      clearInterval(a);
    };
  }
  async function r({ orderIdentifier: s }) {
    try {
      let i = await (await fetch(`${m(e)}/api/sdk/orders/${s}/status`, { method: "GET", headers: {} })).json();
      return i.error ? [] : i;
    } catch (i) {
      return console.error("Error fetching order status", i), [];
    }
  }
  return { listenToMintingEvents: n };
}
function H({ environment: e } = {}) {
  let n = m(e);
  function r(s) {
    window.addEventListener("message", (i) => {
      i.origin === n && Object.values(F).includes(i.data.type) && s(i);
    });
  }
  return { listenToEvents: r };
}
const G = ["src"], Y = /* @__PURE__ */ _({
  __name: "CrossmintPaymentElement",
  props: {
    clientId: null,
    mintConfig: null,
    recipient: null,
    paymentMethod: null,
    currency: null,
    locale: null,
    uiConfig: null,
    environment: null,
    onEvent: null
  },
  setup(e) {
    const n = e, { getIframeUrl: r, listenToEvents: s, emitQueryParams: i } = k(n), { listenToEvents: d } = H({ environment: n.environment }), c = r(), u = f(0);
    return s((o) => {
      var l;
      return (l = n.onEvent) == null ? void 0 : l.call(n, o.data);
    }), d((o) => {
      const { type: l, payload: a } = o.data;
      switch (l) {
        case "ui:height.changed":
          u.value = a.height;
          break;
        default:
          return;
      }
    }), C(
      () => [n.recipient, n.mintConfig, n.locale],
      () => {
        i({ recipient: n.recipient, mintConfig: n.mintConfig, locale: n.locale });
      },
      { deep: !0 }
    ), (o, l) => (I(), y("iframe", {
      src: T(c),
      allow: "payment *",
      id: "iframe-crossmint-payment-element",
      style: A({ height: `${u.value}px` })
    }, null, 12, G));
  }
});
const b = (e, n) => {
  const r = e.__vccOpts || e;
  for (const [s, i] of n)
    r[s] = i;
  return r;
}, j = /* @__PURE__ */ b(Y, [["__scopeId", "data-v-bc9340e1"]]), x = {
  install: (e) => {
    e.component("CrossmintPaymentElement", j);
  }
};
export {
  p as CheckoutEvents,
  j as CrossmintPaymentElement,
  x as default,
  $ as useCrossmintEvents
};
